/*eslint-disable */
/**
 * PS_PT_02
 * Import the required packages, components, interfaces
 */
import React, { useContext, useEffect, useState } from 'react';
import { takePaymentStyles } from '../../stylesJS/makeStyles';
import {
  RACButton,
  RACModalCard,
  Grid,
  Typography,
  Card,
  Box,
  CircularProgress,
  RACAccordion,
  useMediaQuery,
  RACTooltip,
  RACChip,
} from '@rentacenter/racstrap';
import { agreementContext } from '../context/PaymentInformationContext';
import { GetAlert, GetCustomerAlert, UpdateAlert,GetCustomerByIdInfo } from '../../api/user';
import { AlertPopupComponent } from './AlertPopupComponent';
import { useHistory, useParams } from 'react-router-dom';
import { ReactComponent as ExpandCancel } from '../../assets/images/alert-cancel-icon.svg';
import { ReactComponent as ExpandAlert } from '../../assets/images/expand-alert-icon.svg';
import { CustomerPaymentInformation } from './CustomerPaymentInformation';
import { CustomerInformation } from './CustomerInformation';
import { ParamType } from '../interface/commonInterface';
import {
  UpdateAlertPayload,
  CustomerAlert,
} from '../interface/paymentTriangleInterface';
import { paymentTriangleStyle } from '../stylesJS/paymentTriangleStyle';
import { useMutation, useQueries, useQueryClient } from '@tanstack/react-query';
import CONSTANTS from '../constants/constant';
import { Alerts } from '../interface/alertPopupInterface';
import { AgreementContextValue } from '../interface/contextInterface';
import { useTranslation } from 'react-i18next';
import { CustomerdataContext } from '../../context/customer/customerdata';
import moment from 'moment';
import { GeneralStateContext } from '../../context/GeneralProvider';
/**
 * PS_PT_03 - PS_PT_31
 * Declaring PaymentTriangleComponent()
 * That displays customer details and alerts in the page load.
 * @returns
 */
export default function PaymentTriangleComponent({customerByIdInfo}) {

  /**
   * PS_PT_04 - PS_PT_11
   * Declaring and initializing variables
   * Making api calls using useQueries and useMutation
   */
   const { customerInformation } = useContext(GeneralStateContext);
  const classes = takePaymentStyles();
  const useStyleClasses = paymentTriangleStyle();
  const history = useHistory();
  const { customerId } = useParams<ParamType>();
  const { t } = useTranslation("Autopay");
  const {
    customerInfo,
    coWorkerDetails,
    paymentHistoryResponse,
    featureFlags,
  } = useContext<AgreementContextValue>(agreementContext);

  const [customerAlert, setCustomerAlert] = useState<CustomerAlert[]>([]);
  const [loaderFlag, setLoaderFlag] = useState<boolean>(false);
  const [alertFlag, setAlertFlag] = useState<boolean>(false);
  const [alerts, setAlerts] = useState<Alerts[]>([]);
  const queryClient = useQueryClient();
  const totalRevenueAmount =
    paymentHistoryResponse?.payHistoryAgr?.value?.customerInfo
      ?.totalRentalRevenue;
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const { customerdata, setcustomerdata } = useContext(CustomerdataContext);
const storeNumber: string | null = sessionStorage.getItem(
    CONSTANTS.STORE_NUMBER
  );
  /**
   * PS_PT_09
   * Making GetCustomerAlert and GetAlert api calls using useQueries
   */
  const [customerAlertResponse, alertResponse] = useQueries({
    queries: [
      {
        queryKey: [CONSTANTS.API_KEY_GET_CUSTOMER_ALERT],
        queryFn: () => GetCustomerAlert(customerId),
        onSuccess: () => setLoaderFlag(false),
      },
      {
        queryKey: [CONSTANTS.API_KEY_GET_ALERT],
        queryFn: () => GetAlert(customerId),
      },
     
    ],
  });
  /**
   * PS_PT_10 - PS_PT_11
   * Making UpdateAlert api call using useMutation
   * In the success state of UpdateAlert call GetCustomerAlert again using invalidateQueries
   */
  const mutation = useMutation({
    mutationFn: (payload: UpdateAlertPayload) =>
      UpdateAlert(payload, customerId),
    onSuccess: () => {
      queryClient.invalidateQueries([CONSTANTS.API_KEY_GET_CUSTOMER_ALERT]);
      setLoaderFlag(false);
    },
    onError: () => {
      setLoaderFlag(false);
    },
  });
  /**
   * PS_PT_12 - PS_PT_13
   * Declare UseEffect with dependency as customerAlertResponse.data, alertResponse.data
   * Call getCustomerAlertDetails on success of the dependency
   */
  useEffect(() => {
    if (customerAlertResponse?.data && alertResponse?.data)
      getCustomerAlertDetails();
  }, [customerAlertResponse?.data, alertResponse?.data]);

  useEffect(() => {
    if (customerAlertResponse?.data && customerAlertResponse?.data?.customerAlertByIdDTO?.value?.customeralert && JSON.stringify(customerAlertResponse?.data?.customerAlertByIdDTO?.value?.customeralert) != JSON.stringify(customerAlert))
      setCustomerAlert(
        customerAlertResponse?.data.customerAlertByIdDTO?.value?.customeralert ??
        []
      );
  }, [customerAlertResponse]);

     useEffect(() => {
    getEmpDetails();
  }, 
   // eslint-disable-next-line react-hooks/exhaustive-deps
  [customerByIdInfo]);


  const getEmpDetails = () => {
     const employerReferences=customerByIdInfo?.data?.data?.GetCustomer?.value?.employerReferences
    if (Array.isArray(employerReferences) && employerReferences.length > 0) {
      setcustomerdata(customerByIdInfo?.data)
    }
  }

 

  /**
   * PS_PT_14
   * Declare a function as getCustomerAlertDetails
   * It sets the customer alert and alert to state variable
   */
  const getCustomerAlertDetails = async () => {
    setCustomerAlert(
      customerAlertResponse?.data.customerAlertByIdDTO?.value?.customeralert ??
      []
    );
    setAlerts(alertResponse.data.alert);
  };
  /**
   * PS_PT_17 - PS_PT_19
   * This bindCustomerAlert() bind the customer alert to UI
   * @returns
   */
  const bindCustomerAlert = () => {
    console.log('Customer ALerts', customerAlert);
    const language: any = window.sessionStorage.getItem('language');
    const alertData: any = customerAlert?.map(
      (alert: CustomerAlert, index: string | number) => {
        if (alert.alertCleared == CONSTANTS.ZERO_NUMBER) {
          return (
            <>
              <span
                className={`${classes.alertWidgetStyle} ${classes.me2}`}
                key={index}
                data-testid={`alert-${alert.customerAlertId}`}
              >
                {alert.alertTypeId !== CONSTANTS.THREE_STRING &&
                  alert.alertTypeId !== CONSTANTS.THREE_NUMBER && (
                    <a
                     onClick={() =>
                        history.push(`/customer/update/${customerId}/customer?alertTypeId=${alert.alertTypeId}`)
                      }
                      className={classes.me2}
                      data-testid={`expand${alert.customerAlertId}`}
                    >
                      <ExpandAlert></ExpandAlert>
                    </a>
                  )}
                {alert.alertTypeDescEn === CONSTANTS.OTHER
                  ? alert.alertText
                  : language == "es-MX"
                    ? alert.alertTypeDescEs
                    : alert.alertTypeDescEn}
                <a
                  className={classes.ms2}
                  data-testid={`cancel${alert.customerAlertId}`}
                >
                  <ExpandCancel
                    onClick={() => removeAlert(alert.customerAlertId)}
                  ></ExpandCancel>
                </a>
              </span>
              {/* {isMediumScreen && index == customerAlert.length - 1 && (
                <Grid container className={`${classes.p10px}`}>
                  {loaderFlag && (
                    <Grid
                      item
                    >
                      <Grid
                        item
                        className={`${classes.textright} ${classes.me2} ${classes.mt2}`}
                      >
                        <CircularProgress className={classes.loaderIcon} />
                      </Grid>
                    </Grid>
                  )}
                  <Grid item>
                    <RACButton
                      variant="contained"
                      color="primary"
                      isRounded={false}
                      data-testid="assignAlert"
                      onClick={() => setAlertFlag(true)}
                      style={{ minWidth: '25px', padding: '0' }}
                    >
                      {isMediumScreen ? `+` : `Assign Alert`}
                    </RACButton>
                  </Grid>
                </Grid>
              )} */}
            </>
          );
        }
      }
    );

    if ((alertData?.length == 0 && isMediumScreen) || (alertData?.length && isMediumScreen)) {
      alertData.push(
        <span>
          <Grid container className={`${classes.p10px}`}>
            {loaderFlag && (
              <Grid item>
                <Grid
                  item
                  className={`${classes.textright} ${classes.me2}`}
                >
                  <CircularProgress className={classes.loaderIcon} />
                </Grid>
              </Grid>
            )}
            <Grid item>
              <RACButton
                variant="contained"
                color="primary"
                isRounded={false}
                data-testid="assignAlert"
                onClick={() => setAlertFlag(true)}
                style={{ minWidth: "25px", padding: "0" }}
              >
                {isMediumScreen ? `+` : t('Assign Alert')}
              </RACButton>
            </Grid>
          </Grid>
        </span>
      );
      return alertData;
    } else {
      return alertData;
    }
  };
  /**
   * PS_PT_20 - PS_PT_25
   * This function removeAlert removes alert when coWorker clicks on cross icon
   * @param alertId
   */
  const removeAlert = async (alertId: string) => {
    setLoaderFlag(true);
    const removedAlert: CustomerAlert | undefined = customerAlert.find(
      (eachAlert: CustomerAlert) => eachAlert.customerAlertId === alertId
    );
    const payload: UpdateAlertPayload = {
      alertTypes: [
        {
          alertTypeId: Number(removedAlert?.alertTypeId),
          customerAlertId: Number(removedAlert?.customerAlertId),
          alertText: removedAlert?.alertText ?? CONSTANTS.EMPTY_STRING,
          alertClear: CONSTANTS.ONE_NUMBER,
        },
      ],
      customerId: Number(customerId),
      userId: coWorkerDetails.employeeId,
    };
    await mutation.mutateAsync(payload);
  };

  const alertCounter = () => {
    return customerAlert?.length > 0
      ? customerAlert.reduce(
        (count, alert) =>
          alert.alertCleared == CONSTANTS.ZERO_NUMBER ? count + 1 : count,
        0
      )
      : CONSTANTS.ZERO_NUMBER;
  };

  // Use media queries for responsive design
  const isSmallScreen = useMediaQuery('(max-width:600px)'); // for xs screens
  const isMediumScreen = useMediaQuery('(min-width:600px) and (max-width:1280px)'); // for sm screens
 
function getOrdinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
 
  /**
   * PS_PT_26 - PS_PT_31
   * This return statement holds the HTML part for this component
   */
  return (
    <>
      <Card
        className={`${classes.card} ${classes.w100} ${classes.floatLeft}  ${classes.alertwidget}`}
        id="accordionExample"
      >
        <Grid item className={classes.px0}>
          <Grid
            item
            className={`${classes.w100} ${classes.floatLeft}`}
            id="headingOne"
          >
            <Grid
              container
              className={`${classes.px2} ${classes.responsiveGrid}`}
            >
              <Grid
                className={`${classes.raccollg5} ${classes.paymentAlignCenter} ${classes.floatLeft} ${classes.borderrightstyle} ${classes.responsiveGridheader}`}
              >
                <Grid
                  item
                  className={`${classes.customerPaymentPadding}  ${classes.floatLeft}`}
                >
                  <Typography
                    component="span"
                    className={`${classes.titletxtstyle} ${classes.bold} ${classes.pe4} ${classes.floatLeft}`}
                  >
                    {t("Customer Payment")}
                  </Typography>
                </Grid>
                <Grid className={`${classes.responsiveGridRow}`}>
                  <Grid
                    item
                    className={`${classes.customerNamePadding} ${classes.floatLeft} ${classes.responsiveNameHeader}`}
                  >
                    <Box
                      component="span"
                      className={`${classes.labeltxtstyle} ${classes.w100} ${classes.floatLeft}`}
                    >
                      {t("Customer Name")}
                    </Box>
                    {totalRevenueAmount &&
                      featureFlags.CustomerRewards == CONSTANTS.ONE_STRING &&
                      Number(totalRevenueAmount) >=
                      Number(featureFlags.RewardsEligibilityAmount) ? (
                      <>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                            width: '100%'
                          }}
                        >
                          <span
                            onMouseOver={() => {
                              setShowTooltip(true);
                            }}
                            onMouseOut={() => {
                              setShowTooltip(false);
                            }}
                            style={{
                              backgroundColor: featureFlags?.EnableCustomerTierReward != '1' ? "#198754" : '#2179FE',
                              color: "white",
                              padding: "1px 7px",
                              borderRadius: "11px",
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              history.push(
                                `/customer/update/${customerId}/customer`
                              );
                            }}
                          >
                            {customerInfo?.customerDetails[0]?.firstName +
                              " " +
                              customerInfo?.customerDetails[0]?.lastName}
                          </span>
                          {showTooltip && featureFlags?.EnableCustomerTierReward != '1' && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                marginBottom: "5px",
                                backgroundColor: "#ECF0F3",
                                color: "black",
                                padding: "5px",
                                borderRadius: "10px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                zIndex: 2000,
                                fontWeight: "bold",
                              }}
                            >
                              {t("Eligible for RAC Select Rewards")}
                            </div>
                          )}
                        </div>
                        {/* <RACTooltip placement='top' title='Eligible for RAC Select Rewards' classes={{ tooltip: classes.tooltipcss1, arrow: classes.tooltipStyling1 }}>
                          <RACChip icon={false} className={`${classes.chipStyle}`} size="small" label={customerInfo?.customerDetails[0]?.firstName + " " + customerInfo?.customerDetails[0]?.lastName}
                            onClick={() => history.push(`/customer/update/${customerId}/customer`)}
                          />
                        </RACTooltip> */}
                      </>
                    ) : (
                      <a
                        className={`${classes.labelbluetxtstyle} ${classes.w100} ${classes.floatLeft}`}
                        onClick={() => {
                          history.push(
                            `/customer/update/${customerId}/customer`
                          );
                        }}
                      >
                        {customerInfo?.customerDetails[0]?.firstName +
                          " " +
                          customerInfo?.customerDetails[0]?.lastName}
                      </a>
                    )}
                  </Grid>
                  <Grid
                    className={`${classes.floatLeft} ${classes.schedulePadding} ${classes.px1} ${classes.responsiveScheduleHeader}`}
                  >
                    <Box
                      component="span"
                      className={`${classes.labeltxtstyle} ${classes.w100} ${classes.floatLeft} ${classes.p1}`}
                    >
                      {t("Schedule")} :{" "}
                      <span className={`${classes.labelnotxtstyle}`}>
                        {t(customerInfo?.schedule) || CONSTANTS.HYPHEN}
                      </span>
                    </Box>
                    <Box
                      component="span"
                      className={`${classes.labeltxtstyle} ${classes.w100} ${classes.floatLeft} ${classes.p1}`}
                    >
                      {t("Day Paid")}: {" "}
                      <span className={`${classes.labelnotxtstyle}`}>
                        {
                          featureFlags?.EnablePaydayFrequencyCustomer === '1' ? (
                            customerInfo?.schedule === 'Semi-Monthly' ? (
                              customerdata?.data?.GetCustomer?.value?.employerReferences[0].nextPayDate && 
                              customerdata?.data?.GetCustomer?.value?.employerReferences[0].secondPayDate
                                ? `${getOrdinal(moment(customerdata?.data?.GetCustomer?.value?.employerReferences[0].nextPayDate).date())} & 
                                ${getOrdinal(moment(customerdata?.data?.GetCustomer?.value?.employerReferences[0].secondPayDate).date())}`
                                : CONSTANTS.HYPHEN
                            ) : customerInfo?.schedule === 'Monthly' ? (
                              getOrdinal(customerInfo?.dayPaid)
                            ) : (
                              customerInfo?.dayPaid || CONSTANTS.HYPHEN
                            )
                          ) : (
                              customerInfo?.dayPaid || CONSTANTS.HYPHEN
                            ) 
                        }
                        
                      </span>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                className={`${classes.raccollg7} ${classes.paymentAlignCenter} ${classes.floatLeft} ${classes.respAlertContainer}`}
              >
                <Grid
                  item
                  className={`${classes.raccollg7} ${classes.floatLeft} ${classes.ps2} ${classes.respWidth100p}`}
                >
                  <Grid item className={`${classes.w100} ${classes.mt2}`}>
                    <React.Fragment>
                      <Typography
                        variant="h4"
                        className={`${classes.font14} ${classes.semibold} ${classes.floatLeft} ${classes.me1}`}
                      >
                        {t("Customer Alerts")}
                      </Typography>
                      <Typography
                        variant="h4"
                        className={`${classes.font14} ${classes.semibold} ${classes.floatLeft}  ${classes.me4} ${classes.alertcolor}`}
                        data-testid="alertCount"
                      >
                        {alertCounter() > 0 && `(${alertCounter()})`}
                      </Typography>
                    </React.Fragment>

                    <Grid
                      item
                      className={isMediumScreen ? `${classes.alertwidgartcontainer} ${classes.alertwidgartcontainerResp} ${classes.overflowAuto}` : `${classes.alertwidgartcontainer} ${classes.alertwidgartcontainerResp}`}
                    >
                      {bindCustomerAlert()}
                    </Grid>
                  </Grid>
                </Grid>
                {!isMediumScreen && (<Grid
                  item
                  className={`${classes.raccollg5} ${classes.floatLeft} ${classes.ps2} ${classes.respWidth100p}`}
                >
                  <Grid container>
                    {loaderFlag && (
                      <Grid item className={`${classes.raccollg4} ${classes.respWidth10p}`}>
                        <Grid
                          item
                          className={`${classes.textright} ${classes.me2} ${classes.mt2}`}
                        >
                          <CircularProgress className={classes.loaderIcon} />
                        </Grid>
                      </Grid>
                    )}
                    <Grid item className={classes.raccollg6}>
                      <RACButton
                        variant="contained"
                        color="primary"
                        isRounded={false}
                        data-testid="assignAlert"
                        onClick={() => setAlertFlag(true)}
                      >
                        {isMediumScreen ? `+` : t(`Assign Alert`)}
                      </RACButton>
                    </Grid>
                  </Grid>
                </Grid>)}
                <RACModalCard
                  isOpen={alertFlag}
                  maxWidth="xs"
                  title={t("Customer Alerts")}
                  onClose={() => {
                    setAlertFlag(false);
                  }}
                  closeIcon={true}
                >
                  <AlertPopupComponent
                    customerAlert={customerAlert}
                    alerts={alerts}
                    setAlertFlag={() => setAlertFlag(false)}
                    setLoader={() => setLoaderFlag(true)}
                  />
                </RACModalCard>
              </Grid>
            </Grid>
            {!isMediumScreen && (
              <RACAccordion
                details={
                  <>
                     <CustomerInformation/> <CustomerPaymentInformation customerByIdInfo={customerByIdInfo} />
                  </>
                }
                accordionProps={{
                  classes: {
                    root: useStyleClasses.customerInformationRoot,
                  },
                }}
                summaryProps={{
                  classes: {
                    root: useStyleClasses.accordionSummaryRoot,
                    content: useStyleClasses.accordionSummaryContent,
                  },
                }}
              />
            )}
          </Grid>
        </Grid>
      </Card>
    </>
  );
}
